export default "__VITE_ASSET__Dmjy7fXK__"